import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Modal, Typography, generateUtilityClasses } from '@mui/material'
import { styled } from '@mui/system'
import React, { useEffect, useMemo, useState } from 'react'
import { Form } from 'react-final-form'
import DropdownFieldSearch from '../../../../ui/DropdownFieldSearch'
import { CustomCircular, TextField } from '../../../../ui'
import Button from '@mui/material/Button'
import LoadingButton from '@mui/lab/LoadingButton'
import { UspConfigurationCallOutcomeViewResult } from '../../../../models/apiTypes'
import { useAddCallOutcomeMutation, useEditCallOutcomeMutation, useLazyGetCallOutcomeQuery } from '../../../../services'

const classes = generateUtilityClasses('Box', ['root', 'row', 'buttonWrap', 'saveBtn'])

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.root}`]: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '390px',
    backgroundColor: theme.palette.background.main,
    boxShadow: 24,
    padding: theme.spacing(3),
  },
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  [`& .${classes.buttonWrap}`]: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row-reverse',
    padding: theme.spacing(3, 0, 2, 0),
    marginTop: 'auto',
  },
  [`& .${classes.saveBtn}`]: {
    marginLeft: theme.spacing(2),
  },
}))

interface Props {
  rowData: UspConfigurationCallOutcomeViewResult
  open: boolean
  onClose: () => void
  type: string
  submit: (...args: any) => any
}
const AddEditCallOutcomes = ({ open, onClose, rowData, type, submit }: Props) => {
  const [initialValues, setInitialValues] = useState({})
  const [addCallOutcomes, { isLoading: isLoadingCallOutcomes, isSuccess: isSuccessCallOutcomes }] = useAddCallOutcomeMutation()
  const [editCallOutcomes, { isLoading: isLoadingEditCallOutcomes, isSuccess: isSuccessEditCallOutcomes }] = useEditCallOutcomeMutation()
  const [getCallOutcomesData, { isLoading: isLoadingGetCallOutcomes, isSuccess: isSuccessGetCallOutcomes, data }] = useLazyGetCallOutcomeQuery()

  const handleSubmit = (values: any) => {
    if (type === 'edit') {
      editCallOutcomes({
        callOutcomeId: rowData?.ID?.toString(),
        uspConfigurationCallOutcomeAddEdit: {
          outcome: values.Outcome,
          isActive: values.IsActive,
        },
      })
    } else {
      addCallOutcomes({
        uspConfigurationCallOutcomeAddEdit: {
          outcome: values.Outcome,
          isActive: values.IsActive,
        },
      })
    }
  }

  useEffect(() => {
    if (open && rowData && type === 'edit')
      getCallOutcomesData({
        callOutcomeId: rowData?.ID?.toString() as string,
      })
  }, [open, type, rowData])

  useEffect(() => {
    if (type === 'add') {
      setInitialValues({
        Outcome: '',
        IsActive: true,
      })
    }
    if (isSuccessGetCallOutcomes && type === 'edit') {
      setInitialValues({
        Outcome: data?.Outcome,
        IsActive: data?.IsActive,
      })
    }
  }, [isSuccessGetCallOutcomes, data, type])

  useEffect(() => {
    if (isSuccessCallOutcomes || isSuccessEditCallOutcomes) {
      onClose()
      submit()
    }
  }, [isSuccessCallOutcomes, isSuccessEditCallOutcomes])

  const isLoading = useMemo(
    () => isLoadingGetCallOutcomes || isLoadingEditCallOutcomes || isLoadingCallOutcomes,
    [isLoadingGetCallOutcomes, isLoadingEditCallOutcomes, isLoadingCallOutcomes],
  )
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Call Outcome</DialogTitle>
      <Form onSubmit={handleSubmit} initialValues={initialValues}>
        {({ handleSubmit }: any) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={2} py={1}>
                <Grid item xs={12}>
                  <TextField required name='Outcome' label='Outcome' fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <DropdownFieldSearch
                    name='IsActive'
                    label='Is Active?'
                    options={[
                      { key: true, values: 'Yes' },
                      { key: false, values: 'No' },
                    ]}
                    optionKey='key'
                    optionValue='values'
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <LoadingButton type='submit' className={classes.saveBtn} variant='contained'>
                Save
              </LoadingButton>
              <Button variant='contained' color='error' onClick={onClose}>
                Cancel
              </Button>
            </DialogActions>
          </form>
        )}
      </Form>
      <CustomCircular open={isLoading} />
    </Dialog>
  )
}

export default AddEditCallOutcomes
